import { KNOWLEDGE_ITEM_TYPES } from '../knowledgeItems/knowledgeItemModel';

const MEDICATION_TERMS =
  /\b(?:medication|medications|medicine|medicines|prescription|prescriptions|dose|dosage|inhaler)\b/i;
const ALLERGY_TERMS = /\b(?:allergy|allergies|allergic)\b/i;

const getFactText = (fact = {}) =>
  [fact.summary, fact.title, fact.fact, fact.value]
    .filter(Boolean)
    .join(' ');

export const isStructuredMedicationFact = (fact = {}) =>
  fact.knowledgeType === KNOWLEDGE_ITEM_TYPES.MEDICATION ||
  MEDICATION_TERMS.test(getFactText(fact));

export const isStructuredAllergyFact = (fact = {}) =>
  ALLERGY_TERMS.test(getFactText(fact));
